<template>
  <o-view>
    <o-nav-bar
      title="Actieve route"
      :has-back-button="true"
    />
    <o-route-details/>
  </o-view>
</template>

<script>
import ORouteDetails from '@/components/ORouteDetails.vue'
export default {
  name: 'ActiveRoute',
  components: {
    ORouteDetails
  }
}
</script>
